// extracted by mini-css-extract-plugin
export default {"container":"components-settings-budget-forecast-version-history-drawer-module__container"};